module.exports = __webpack_public_path__ + "static/xamp-762ac84cb396e8ab30eb1766580d97fa.png";